import {
  ACCOUNT_SELECTED,
  BACK_CLICKED,
  BACK_CLICKED_WITH_FORM_VALUES,
  CANCEL_CLICKED,
  CANCEL_DIRECT_DEBIT_FAILED,
  CANCEL_DIRECT_DEBIT_SUCCEEDED,
  FORM_SUBMITTED,
  PAGES,
  PAYMENT_TYPES,
  SET_DIRECT_DEBIT_FAILED,
  SET_DIRECT_DEBIT_SUCCEEDED,
} from "./constants";
import { Action, RadioButtonOption, State } from "./types";

export const paymentTypes: RadioButtonOption[] = [
  {
    label: "Minimum monthly payment + any overdue and overlimit amount",
    value: PAYMENT_TYPES.MINIMUM_MONTHLY,
    description: "Pay to keep your account up to date",
  },
  {
    label: "Full statement closing balance",
    value: PAYMENT_TYPES.FULL_CLOSING,
    description: "What you might like to pay to save on interest",
  },
  {
    label: "Specify a fixed monthly amount",
    value: PAYMENT_TYPES.FIXED,
  },
];

export const emptyFormValues = {
  accountName: "",
  jointAccount: "",
  bankName: "",
  bsb: "",
  accountNumber: "",
  paymentType: paymentTypes[0].value,
  paymentAmount: "",
};

const initialDirectDebitState: State = {
  page: PAGES.LANDING,
  toAccount: undefined,
  formValues: emptyFormValues,
  errorType: undefined,
};

const directDebitReducer = (state: State, action: Action): State => {
  switch (state.page) {
    case PAGES.LANDING: {
      switch (action.type) {
        case ACCOUNT_SELECTED: {
          return {
            ...state,
            toAccount: action.toAccount,
            ...(action.toAccount.id !== state.toAccount?.id && {
              formValues: emptyFormValues,
            }),
          };
        }

        case FORM_SUBMITTED: {
          return {
            ...state,
            page: PAGES.FORM,
          };
        }

        case CANCEL_CLICKED: {
          return {
            ...state,
            page: PAGES.CANCEL,
          };
        }

        default: {
          return state;
        }
      }
    }

    case PAGES.FORM: {
      switch (action.type) {
        case SET_DIRECT_DEBIT_SUCCEEDED: {
          return {
            ...state,
            page: PAGES.SUCCESS,
            formValues: action.formValues,
          };
        }

        case SET_DIRECT_DEBIT_FAILED: {
          return {
            ...state,
            page: PAGES.ERROR,
            errorType: action.errorType,
          };
        }

        case BACK_CLICKED_WITH_FORM_VALUES: {
          return {
            ...state,
            page: PAGES.LANDING,
            formValues: action.formValues,
          };
        }

        default: {
          return state;
        }
      }
    }

    case PAGES.CANCEL: {
      switch (action.type) {
        case CANCEL_DIRECT_DEBIT_SUCCEEDED: {
          return {
            ...state,
            page: PAGES.CANCEL_SUCCESS,
          };
        }

        case BACK_CLICKED: {
          return {
            ...state,
            page: PAGES.LANDING,
          };
        }

        case CANCEL_DIRECT_DEBIT_FAILED: {
          return {
            ...state,
            page: PAGES.ERROR,
            errorType: "UNEXPECTED_ERROR",
          };
        }

        default: {
          return state;
        }
      }
    }

    default: {
      return state;
    }
  }
};

export { PAGES, initialDirectDebitState, directDebitReducer };
